<template>
  <div>
    <page-toolbar>
      <kendo-button icon="add" title="Add new" @click="addRecord" v-if="!isReadOnly">
      </kendo-button>
      <kendo-dropdownlist
        v-model="sendingMessageReportId"
        :data-source="sendingMessageReportDataSource"
        :data-text-field="'sendingMessageReportName'"
        :data-value-field="'sendingMessageReportId'"
        @change="sendingMessageReportDropDownListChange"
      ></kendo-dropdownlist>
      <kendo-dropdownlist
        v-model="languageId"
        :data-source="languageDataSource"
        :data-text-field="'languageName'"
        :data-value-field="'languageId'"
        @change="languageDropDownListChange"
        style="width:100px"
      ></kendo-dropdownlist>
    </page-toolbar>
    <div style="height:calc(100vh - 182px)" ref="sendingMessageGrid"></div>
  </div>
</template>
<script>
import $ from '../../helpers/jquery-bridge'
import PageToolbar from '@/components/PageToolbar'
import {enableExportExcel} from '../../helpers/export-helper'
import {getDataItem} from '@/helpers/kendo-helpers'
import {datePickerEditor, jsonDropDownEditor, readOnlyEditor} from '../../helpers/kendo-editors'
import security from '@/mixins/security'
import {mapGetters} from 'vuex'

export default {
  mixins: [security],
  components: {
    PageToolbar,
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  data() {
    return {
      sendingMessageReportId: -1,
      sendingMessageReportDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/config/sendingMessage/getRefSendingMessageReports?addAll=true',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
      languageId: -1,
      languageDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/config/sendingMessage/getLanguages?addAll=true',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
    }
  },
  mounted() {
    let vm = this
    let grid = $(vm.$refs.sendingMessageGrid)
      .kendoGrid({
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 16,
          transport: {
            create: {
              type: 'POST',
              url: '/api/config/sendingMessage',
              dataType: 'json',
            },
            read: {
              type: 'GET',
              url: '/api/config/sendingMessage',
              dataType: 'json',
              data: () => {
                return {
                  sendingMessageReportId: vm.sendingMessageReportId,
                  languageId: vm.languageId,
                  clientId: vm.clientId,
                }
              },
            },
            update: {
              type: 'PUT',
              url: '/api/config/sendingMessage',
              dataType: 'json',
            },
            destroy: {
              type: 'DELETE',
              url: '/api/config/sendingMessage',
              dataType: 'json',
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'sendingMessageId',
              fields: {
                sendingMessageId: {type: 'number', validation: {required: true}},
                sendingMessageReportId: {type: 'number', validation: {required: true}},
                sendingMessageReportName: {type: 'string', validation: {required: true}},
                clientId: {type: 'number', validation: {required: true}},
                clientName: {type: 'string', validation: {required: true}},
                languageId: {type: 'number', validation: {required: true}, defaultValue: 1},
                languageName: {type: 'string', validation: {required: true}},
                name: {type: 'string', validation: {required: true}},
                subject: {type: 'string'},
                message: {type: 'string'},
                canDelete: {type: 'boolean', defaultValue: true},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              e.preventDefault()
            })
          },
        }),
        editable: !vm.isReadOnly && 'inline',
        filterable: true,
        sortable: true,
        pageable: true,
        columns: [
          {
            command: [{name: 'edit'}],
            width: 64,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
          {
            field: 'sendingMessageReportName',
            title: 'Report',
            width: 182,
            template: '#=sendingMessageReportName#',
            editor: function(container, options) {
              const sendingMessageId = options.model.sendingMessageId
              if (sendingMessageId != 1) {
                return jsonDropDownEditor(
                  'sendingMessageReportId',
                  'sendingMessageReportName',
                  '/api/config/sendingMessage/getRefSendingMessageReports?allAll=false',
                  {
                    change: e => {
                      let rowItem = getDataItem(e.sender.element)
                      rowItem.set('sendingMessageReportName', e.sender.text())
                      rowItem.set('hasMessage', e.sender.dataItem().hasMessage)
                    },
                    dataBound: function(e) {
                      let rowItem = getDataItem(e.sender.element)
                      if (rowItem.id == 0 && vm.sendingMessageReportId > 0) {
                        this.value(vm.sendingMessageReportId)
                      } else if (rowItem.sendingMessageId == 0) {
                        this.select(0)
                      }
                      this.trigger('change')
                    },
                  },
                ).call(this, container, options)
              } else {
                return readOnlyEditor.call(this, container, options)
              }
            },
          },
          {
            field: 'clientName',
            title: 'Client',
            width: 182,
            template: '#=clientName#',
            editor: function(container, options) {
              return jsonDropDownEditor(
                'clientId',
                'clientName',
                `/api/config/sendingMessage/getClients?clientId=${vm.clientId}`,
                {
                  change: e => {
                    let rowItem = getDataItem(e.sender.element)
                    rowItem.set('clientName', e.sender.text())
                  },
                  dataBound: function(e) {
                    let rowItem = getDataItem(e.sender.element)
                    if (rowItem.sendingMessageId == 0) this.select(0)
                    this.trigger('change')
                  },
                },
              ).call(this, container, options)
            },
          },
          {
            field: 'languageName',
            title: 'Language',
            width: 120,
            editor: function(container, options) {
              return jsonDropDownEditor('languageId', 'languageName', '', {
                dataSource: {
                  transport: {
                    read: {
                      url: '/api/config/sendingMessage/GetLanguages',
                      contentType: 'application/json',
                      type: 'GET',
                    },
                  },
                },
                filter: 'contains',
              }).call(this, container, options)
            },
          },
          {
            field: 'name',
            title: 'Message Name',
            width: 132,
          },
          {
            field: 'subject',
            title: 'Subject',
            width: 132,
          },
          {
            field: 'message',
            title: 'Message',
            width: 632,
            template: function(dataItem) {
              if (!dataItem.message) return '<p/>'

              let htmlMessage = dataItem.message
                .replaceAll('\n', '<br/>')
                .replaceAll(
                  '@',
                  '<span style="color:#000;font-weight:bolder;font-size:16px">@</span>',
                )
              return `<p>${htmlMessage}</p>`
            },
            editor: function(container, options) {
              if (options.model.hasMessage) {
                return readOnlyEditor.call(this, container, options)
              } else {
                container.html(
                  `<textarea data-bind="value: ${
                    options.field
                  }" title="Message" class="k-textbox" rows="8"></textarea>`,
                )
              }
            },
          },
          {
            command: [{name: 'destroy', visible: dataItem => dataItem.canDelete}],
            width: 64,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
          {},
        ],
        detailInit: vm.detailInit,
        dataBound: function(e) {
          const items = e.sender.items()
          items.each(function() {
            const row = $(this)
            const dataItem = e.sender.dataItem(row)
            if (!dataItem.hasMessage) {
              row.find('.k-hierarchy-cell').html('')
            }
          })
        },
        detailCollapse: () => grid.dataSource.read(),
        detailExpand: container => container.masterRow.find('.k-grid-delete').hide(),
      })
      .getKendoGrid()

    enableExportExcel(grid, '/api/config/sendingMessage/exportToExcel', $('.page_toolbar-item'))
  },
  methods: {
    addRecord() {
      let grid = $(this.$refs.sendingMessageGrid).getKendoGrid()
      grid.addRow()
    },
    sendingMessageReportDropDownListChange(e) {
      this.sendingMessageReportId = +e.sender.value()
      this.refreshGrid()
    },
    languageDropDownListChange(e) {
      this.languageId = +e.sender.value()
      this.refreshGrid()
    },
    detailInit(e) {
      const vm = this
      const $container = $("<div id='detailGrid'/>")
      const dataItem = e.data
      $container
        .appendTo(e.detailCell)
        .kendoGrid({
          dataSource: {
            type: 'aspnetmvc-ajax',
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            pageSize: 10,
            transport: {
              create: {
                type: 'POST',
                url: '/api/config/sendingMessage/details',
                dataType: 'json',
              },
              read: {
                type: 'GET',
                url: '/api/config/sendingMessage/details',
                data: () => ({
                  sendingMessageId: dataItem.sendingMessageId,
                }),
                dataType: 'json',
              },
              update: {
                type: 'PUT',
                url: '/api/config/sendingMessage/details',
                dataType: 'json',
              },
              destroy: {
                type: 'DELETE',
                url: '/api/config/sendingMessage/details',
                dataType: 'json',
              },
            },
            schema: {
              errors: 'errors',
              total: 'total',
              data: 'data',
              model: {
                id: 'sendingMessageHistoryId',
                fields: {
                  sendingMessageHistoryId: {type: 'number', defaultValue: 0},
                  sendingMessageId: {type: 'number', defaultValue: dataItem.sendingMessageId},
                  message: {type: 'string'},
                  reportDate: {type: 'date'},
                },
              },
            },
          },
          toolbar: !vm.isReadOnly ? ['create'] : '',
          editable: !vm.isReadOnly && 'inline',
          scrollable: true,
          sortable: true,
          pageable: true,
          columns: [
            {
              command: 'edit',
              width: 82,
              attributes: {style: 'text-align: center;'},
              hidden: vm.isReadOnly,
            },
            {
              field: 'reportDate',
              title: 'Report Date',
              width: 132,
              format: '{0:MMM yyyy}',
              template: '#= kendo.toString(reportDate, "MMM yyyy") #',
              editor: function(container, options) {
                return datePickerEditor(
                  {format: 'MMM yyyy', start: 'year', depth: 'year'},
                  true,
                ).call(this, container, options)
              },
            },
            {
              field: 'message',
              title: 'Message',
              width: 632,
              template: function(dataItem) {
                if (!dataItem.message) return '<p/>'

                let htmlMessage = dataItem.message
                  .replaceAll('\n', '<br/>')
                  .replaceAll(
                    '@',
                    '<span style="color:#000;font-weight:bolder;font-size:16px">@</span>',
                  )
                return `<p>${htmlMessage}</p>`
              },
              editor: function(container, options) {
                container.html(
                  `<textarea data-bind="value: ${
                    options.field
                  }" title="Message" class="k-textbox" rows="8"></textarea>`,
                )
              },
            },
            {
              command: [{name: 'destroy'}],
              width: 82,
              attributes: {style: 'text-align: center;'},
              hidden: vm.isReadOnly,
            },
            {},
          ],
        })
        .data('kendoGrid')
    },
    refreshGrid() {
      let grid = $(this.$refs.sendingMessageGrid).getKendoGrid()
      return grid.dataSource.read()
    },
  },
}
</script>
